<template>

    <div class="main-content">
        <div class="row">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-body">
                        <div class="flex">
                            <div>
                                <label for="">Тип SMS</label>
                                <select v-model="smsType" class="form-control">
                                    <option v-for="(type, index) in smsTypes" :value="index">{{type}}</option>
                                </select>
                            </div>
                            <div class="form-group group_select">
                                <label for="">Группа SMS</label>
                                <div>
                                    <input class="form-check-input" type="radio" v-model="groupType" id="inlineRadio1" value="1">
                                    <label class="form-check-label" for="inlineRadio1">Курьерские заявки</label>
                                </div>
                                <div>
                                    <input class="form-check-input" type="radio" v-model="groupType" id="inlineRadio3" value="2">
                                    <label class="form-check-label" for="inlineRadio3">Почтовые заявки</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-if="selectedSMS">
                    <div class="card-body">
                        <div>
                            <textarea rows="10" @keyup='totalSymbols()' class="form-control" v-model="selectedSMS.body" placeholder="Текст для SMS"></textarea>
                        </div>
                        <div class="text-right p-t-10">
                            <span class="pull-left">Символов: <strong>{{totalChars}}</strong></span>
                            <button @click="updateSMS" class="btn btn-success">Сохранить</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header">
                        <h5>Легенда</h5>
                    </div>
                    <div class="card-body">
                        <p><strong>#orderNum</strong> - номер заявки</p>
                        <p><strong>#siteName</strong> - название проекта</p>
                        <p><strong>#siteReviews</strong> - страница отзывов проекта</p>
                        <p><strong>#sitePhoneNumber</strong> - номер телефона проекта</p>
                        <p><strong>#orderPrice</strong> - сумма для оплаты</p>
                        <p><strong>#clientName</strong> - имя клиента</p>
                        <p><strong>#payLink</strong> - ссылка на страницу с реквизитами</p>
                        <p><strong>#cardNum</strong> - номер карты получателя</p>
                        <p><strong>#cardName</strong> - имя получателя получателя</p>
                        <p><strong>#runnerPhone</strong> - номер телефона курьера</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>

    import api from '@/api'

    export default {

        data() {
            return {
                smsType: null,
                smsTypes: null,
                groupType: 1,
                groupTypes: null,
                smsTemplates: null,
                selectedSMS: null,
                totalChars: 0,
                Toast: this.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }),
            }
        },
        mounted() {
            this.getSmsTypes();
        },
        watch: {
            smsType() {
                this.loadBody();
                this.totalSymbols();
                // if (!this.smsTemplates[this.smsType]) ;
                // this.selectedSMS = {
                //     id: this.smsTemplates[this.smsType] ? this.smsTemplates[this.smsType].id : null,
                //     body: this.smsTemplates[this.smsType] ? this.smsTemplates[this.smsType].body : null
                // };
            },
            groupType() {
                this.loadBody();
            }
        },
        methods: {
            totalSymbols: function () {
                this.totalChars = this.selectedSMS ? this.selectedSMS.body.length : 0;
            },
            loadBody() {
                this.selectedSMS = {};
                try{
                    this.selectedSMS.id = this.smsTemplates[this.groupType][this.smsType].id;
                }catch (e){
                    this.selectedSMS.id = null;
                }
                try{
                    this.selectedSMS.body = this.smsTemplates[this.groupType][this.smsType].body;
                }catch (e){
                    this.selectedSMS.body = null;
                }
            },
            async updateSMS(e) {
                e.target.disabled = true;
                let {data} = await api.post('/sms/updateSMS', {
                    id: this.selectedSMS.id,
                    body: this.selectedSMS.body,
                    message_type: this.smsType,
                    group_type: this.groupType
                });

                this.smsTemplates[this.groupType][this.smsType] = {body:this.selectedSMS.body};

                if (data.success) {
                    this.Toast.fire({
                        type: 'success',
                        title: 'Сохранено'
                    })
                } else {
                    this.Toast.fire({
                        type: 'warning',
                        title: data.message || 'Ошибка'
                    })
                }
                e.target.disabled = false;
            },
            async getSmsTypes() {
                let {data} = await api.index('/sms/getSmsTypes');
                this.smsTypes = data.message_types;
                this.groupTypes = data.group_types;
                this.smsTemplates = data.sms;
            }
        }

    }

</script>


<style>
    .flex{
        display: flex;
    }
    .group_select{
        padding-left: 20px;
    }
    .group_select input{
        float: left;
        position: initial;
        margin-left: 0;
        margin-right: 10px;
    }
</style>
